import React, { useState } from 'react';
import FilterTemplate from '../components/filtertemplate/FilterTemplate';
import { CalendarIcon, UserIcon, SwapIcon, CloseIcon, FilterIcon } from '../components/shared/Icons';
import FilterChips from '../components/shared/FilterChips';
import HelpButton from '../components/shared/HelpButton';
import { useUser } from '../utils/UserContext';
import { cssUrl } from '../utils/cssVersion';
import { fetchCleanerData } from '../utils/api';
import { rolesAccess } from '../data/map';
import { CHIP_GROUP_COLORS } from '../components/shared/chipColors';
const filterStyles = cssUrl('filterTemplate.css');

const displayDate = (isoDate) => {
  if (!isoDate) return '';
  const [year, month, day] = isoDate.split('-');
  return `${day}/${month}/${year}`;
};


const CleanersCard = ({ item, onClick, isAdmin }) => {
  

  return (
    <div className="fr-card" onClick={() => onClick(item)}>
      <div className="fr-card-header">
        <div className="fr-card-dates">
          <CalendarIcon />
          <span className="fr-card-date-start">{displayDate(item[7])}</span>
          <span className="fr-card-date-sep">→ Data of Birth</span>
         
        </div>
        <div className="fr-card-status-badge" data-status={item[6]?.toLowerCase()}>
          {item[6]}
        </div>
      </div>

      <div className="fr-card-body">
        <div className="fr-card-row">
          <UserIcon />
          <span className="fr-card-label">Cleaner:</span>
          <span className="fr-card-value">{item[1]}</span>
          
        </div>

        <div className="fr-card-row">
          <SwapIcon />
          <span className="fr-card-label">Police:</span>
          <span className="fr-card-value">{item[8]}</span>
          <span className="fr-card-status-tag" data-status={item[5]?.toLowerCase()}>
           {item[5]}
          </span>
        </div>

        <div className="fr-card-row">
          <UserIcon />
          <span className="fr-card-label">Children:</span>
          <span className="fr-card-value">{item[10]}</span>
          <span className="fr-card-status-tag" data-status={item[11]?.toLowerCase()}>
            {item[11]?.toUpperCase()} 
          </span>
        </div>

      </div>

      <div className="fr-card-footer">
       
        <div className="fr-card-meta">
          <span className="fr-card-meta-item fr-card-middle">
          <FilterIcon />
            Visa Status: {item[9]} &nbsp;  {item[12]}</span>
            
        </div>
        
      </div>

      <div className="fr-card-tap-hint">
      
      Tap to view cleaner

    </div>
    </div>
  );
};


const UpdateTimeModal = ({ item, onClose, isAdmin, user }) => {
  

  if (!item) return null;

 

  return (
    <div className="fr-modal-overlay" onClick={onClose}>
      <div className="fr-modal" onClick={(e) => e.stopPropagation()}>
        <div className="fr-modal-handle" />
        <div className="fr-modal-header">
          <h3 className="fr-modal-title">View Cleaner Info</h3>
          <button className="fr-modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="fr-modal-body">
          <div className="fr-modal-field">
            <label className="fr-modal-label">Cleaner</label>
            <div className="fr-modal-value">{item[1]}</div>
          </div>
          <div className="fr-modal-field">
            <label className="fr-modal-label">Email</label>
            <div className="fr-modal-value">{item[2]}</div>
          </div>
          <div className="fr-modal-field">
            <label className="fr-modal-label">Mobile</label>
            <div className="fr-modal-value">{item[3]}</div>
          </div>
          <div className="fr-modal-field">
            <label className="fr-modal-label">Address</label>
            <div className="fr-modal-value">{item[4]}</div>
          </div>
          <div className="fr-modal-field">
            <label className="fr-modal-label">Banned</label>
            <div className="fr-modal-value">{item[11]?.toUpperCase()}</div>
          </div>
        </div>

        <div className="fr-modal-actions">
          
          

            <button className="fr-modal-btn fr-btn-cancel" onClick={onClose}>
            Close
          </button>
           
          
        </div>
      </div>
    </div>
  );
};



const filterChipGroups = [
  {
    color: CHIP_GROUP_COLORS.cyan,
    values: ['Current'],
  },
  {
    color: CHIP_GROUP_COLORS.violet,
    values: ['Over Due'],
  },
  {
    color: CHIP_GROUP_COLORS.amber,
    values: ['Yes','No'],
  },
  {
    color: CHIP_GROUP_COLORS.rose,
    values: ['Uploaded'],
  },
  {
    color: CHIP_GROUP_COLORS.emerald,
    values: ['Banned'],
  },
];

const CleanersData = ({showHeader = false, template = "1"}) => {
const { user } = useUser();
  const isAdmin = rolesAccess.admin.includes(user?.userJob || '');

  return (
  <FilterTemplate
    title="Cleaners Data"
     helpButton={
      <HelpButton helpData={[
      { chip: 'cleanerscard_filter', urlFilter: '/static/pdffilters/RecruitmentFilter.pdf' }
      ]} />
  }
    subtitle="Cleaners Info"
    searchPlaceholder="Search by all fields values etc policenow..."
    stylesheetHref={filterStyles}
    fetchData={() => fetchCleanerData({ template })}
    dataKey="cleanersinfo"
    searchFields={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11]}
    onSubmit={null}
    loadingMessage="Loading cleaners data..."
    showNavigation={false}
    chipLogic="and"
    showHeader={showHeader}
    renderChips={(chipQuery, setChipQuery, chipsOpen, setChipsOpen) => (
        <FilterChips
          chipGroups={filterChipGroups}
          chipQuery={chipQuery}
          setChipQuery={setChipQuery}
          chipsOpen={chipsOpen}
          setChipsOpen={setChipsOpen}
        />
      )}

    renderCard={(item, onClick) => (
      <CleanersCard item={item} onClick={onClick} isAdmin={isAdmin} />
    )}
    renderModal={(item, onClose) => (
      <UpdateTimeModal
        item={item}
        onClose={onClose}
        isAdmin={isAdmin}
        user={user}
        
      />
    )}
  />
);
};

export default CleanersData;